<template>
  <div class="main">
    <a-card :bordered="false" class="cate-lists">
      <div v-if="lists.length > 0">
        <table-components
          :treeData="lists"
          :dataList="dataList"
          :type="type"
          @getCateList="getCateList"
          @editColumn="editColumn"
          @dataSort="dataSort"
          @dataMerge="dataMerge"
          @add="add"
          @setType="setType"
          :tableLoding="tableLoding"
        ></table-components>
      </div>
    </a-card>

    <a-modal
      :title="columnTitle"
      centered
      v-model="catemodal"
      @cancel="cancelModal"
      @ok="addCate"
      class="cate-type"
    >
      <p>
        <a-input
          placeholder="请输入栏目名称"
          v-model="catname"
          @keyup.enter="addCate"
          style="width: 70%;margin-right: 10px"
        />
        <a-button type="primary" v-if="link" @click="link = false">
          外部链接
          <a-icon type="check" />
        </a-button>
        <a-button type="dashed" v-else @click="link = true">外部链接</a-button>
      </p>
      <div style="margin-bottom:10px;">
        <span style="color:red;"
          >若要一次创建多个栏目，栏目名请用“|”号隔开</span
        >
      </div>
      <p v-if="link">
        <a-input
          placeholder="链接地址"
          v-model="linkurl"
          @keyup.enter="addCate"
        />
      </p>
      <div style="margin-bottom:10px;">
        <a-radio-group
          name="hierarchy"
          v-model="rank"
          @change="
            e => {
              rank = e.target.value;
            }
          "
        >
          <a-radio :value="1">设为一级栏目</a-radio>
          <a-radio :value="2">选择父级栏目</a-radio>
        </a-radio-group>
      </div>
      <p v-if="rank == 2">
        <a-cascader
          :options="optData"
          placeholder="请选择栏目层级"
          :showSearch="{ filter }"
          expandTrigger="hover"
          style="width:400px;"
          changeOnSelect
          :value="level"
          @change="selectHierarchy"
        />
      </p>
      <p>
        展示渠道：
        <span v-for="(item, index) in cType" :key="index">
          <a-button
            @click="setcType(item.value)"
            :key="item.value"
            v-if="selectcType.indexOf(item.value) > -1"
            type="primary"
          >
            <a-icon :type="item.icon" />
            {{ item.label }}
          </a-button>
          <a-button @click="setcType(item.value)" :key="item.value" v-else>
            <a-icon :type="item.icon" />
            {{ item.label }}
          </a-button>
        </span>
      </p>
      <div>
        <div style="height: 32px">栏目简介</div>
        <div>
          <a-textarea
            v-model="intro"
            placeholder="请输入栏目介绍"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </div>
      </div>
      <div>
        <div style="height: 32px">栏目图片：</div>
        <a-upload-dragger
          name="file"
          accept="image/*"
          :headers="headers"
          :beforeUpload="beforeUpload"
          v-if="photo == ''"
        >
          <p class="ant-upload-drag-icon">
            <a-icon type="inbox" />
          </p>
          <p class="ant-upload-hint">点击上传栏目封面图片</p>
        </a-upload-dragger>
        <div v-else class="cover-img" @click="clearImg()">
          <img :src="photo" style="height: 100%;width: 100%" />
        </div>
      </div>
      <p>
        <a-checkbox @change="onSetTemp" :checked="templateSet"
          >设置模板</a-checkbox
        >
      </p>
      <p v-show="templateSet">
        <a-input
          addonBefore="栏目页模板"
          placeholder="请输入模板名称"
          v-model="template.index"
        />
      </p>
      <p v-show="templateSet">
        <a-input
          addonBefore="列表页模板"
          placeholder="请输入模板名称"
          v-model="template.list"
        />
      </p>
      <p v-show="templateSet">
        <a-input
          addonBefore="内容页模板"
          placeholder="请输入模板名称"
          v-model="template.show"
        />
      </p>
      <!--selectcType.indexOf(String(parseInt(index) + 1))-->
      <!--<a-switch checkedChildren="外链" unCheckedChildren="内部" defaultChecked/>-->
    </a-modal>

    <a-modal
      title="合并栏目"
      :visible="mergeColVisible"
      @cancel="mergeColVisible = false"
      @ok="categorymerge"
      :maskClosable="false"
      :confirmLoading="mergeLoading"
    >
      <div style="margin-bottom:10px;">
        <label for>合并栏目：</label>
        <span>{{ mergePrimary.catname }}</span>
      </div>
      <div>
        <label for>目标栏目：</label>
        <a-cascader
          :options="optData"
          placeholder="请选择目标栏目"
          :showSearch="{ filter }"
          style="width:400px;"
          changeOnSelect
          :value="mergeColData"
          @change="mergeSelectHierarchy"
        />
      </div>
    </a-modal>
  </div>
</template>

<script>
import { SlickList, SlickItem, HandleDirective } from 'vue-slicksort';
import tableComponents from './table';
export default {
  directives: { handle: HandleDirective },
  components: {
    SlickItem,
    SlickList,
    tableComponents
  },
  data() {
    return {
      templateSet: false,
      link: false,
      linkurl: '',
      catname: '',
      catemodal: false,
      flag: true,
      lists: [],
      editId: -1,
      intro: '',
      photo: '',
      quickEditId: -1,
      optData: [],
      cType: [
        { icon: 'desktop', label: 'PC', value: '1' },
        { icon: 'mobile', label: 'App', value: '2' },
        { icon: 'html5', label: 'H5', value: '3' }
      ],
      selectcType: '1,2,3',
      template: { index: '', list: '', show: '' },
      headers: {
        Authorization: window.localStorage.getItem('token')
      },
      rank: 1,
      level: [],
      dataList: [],
      columnTitle: '',
      mergeColVisible: false,
      mergeColData: [],
      mergePrimary: {},
      mergeLoading: false,
      tableLoding: true,
      hideCategory: [],
      type: '0'
    };
  },
  created() {
    this.getCateList();
    this.$message.config({
      top: `400px`
    });
  },
  methods: {
    setType(type) {
      this.type = type;
      this.getCateList();
    },
    filter(inputValue, path) {
      return path.some(
        option =>
          option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1
      );
    },
    onSetTemp(e) {
      this.templateSet = e.target.checked;
    },
    clearImg() {
      let that = this;
      this.$confirm({
        title: '删除封面图',
        content: '确认删除当前专题的封面图吗？',
        onOk() {
          that.photo = '';
        },
        onCancel() {}
      });
    },
    async beforeUpload(file) {
      let res = await this.$http.post(
        'https://openapi.ycrmt.cn/aliyun/index/Imgesupload'
      );
      let data = res.data.data;
      let client = new this.$OSS({
        region: data.config.region,
        accessKeyId: data.result.Credentials.AccessKeyId,
        accessKeySecret: data.result.Credentials.AccessKeySecret,
        stsToken: data.result.Credentials.SecurityToken,
        bucket: data.config.bucket
      });
      let options = {
        callback: data.callback
      };
      options.callback.customValue.filename = file.name.substring(
        0,
        file.name.lastIndexOf('.')
      ); //原文件名称
      let date = new Date();
      let year = this.$moment().format('YYYY');
      let month = this.$moment().format('MM');
      let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
      let result = await client.put(
        data.path +
          year +
          '/' +
          month +
          '/' +
          this.$md5(date) +
          '.' +
          fileExtension,
        file,
        options
      );
      if (result.data.errno === 0) {
        this.$message.success('文件上传成功');
        this.photo = result.data.data;
      } else {
        this.$$message.error('文件上传失败');
      }
    },
    setcType(value) {
      let cTypeArr = this.selectcType.split('');
      if (cTypeArr.indexOf(value) > -1) {
        cTypeArr.splice(cTypeArr.indexOf(value), 1);
      } else {
        cTypeArr.push(value);
      }
      cTypeArr.sort();
      this.selectcType = cTypeArr.join('');
    },
    delCate(item, index) {
      let that = this;
      this.$confirm({
        title: '删除栏目',
        content: '删除栏目后将无法恢复，确定操作吗？',
        onOk() {
          that.$http
            .post('/api/content/categorydel', { ids: item.catid })
            .then(res => {
              if (res.data.state == 200) {
                that.$message.success('操作成功');
                that.lists = [];
                that.getCateList();
              } else {
                that.$message.error('操作失败，请刷新页面重试');
              }
            });
        },
        onCancel() {}
      });
    },
    editCate(item, index) {
      this.templateSet = false;
      this.template = { index: '', list: '', show: '' };
      this.editId = index;
      this.catname = item.catname;
      this.intro = item.intro;
      this.photo = item.photo;
      if (item.linkurl != null && item.linkurl != '') {
        this.link = true;
        this.linkurl = item.linkurl;
      } else {
        this.link = false;
        this.linkurl = '';
      }
      if (item.template !== null && item.template != '') {
        this.template = JSON.parse(item.template);
      }
      this.selectcType = item.ctype;
      this.catemodal = true;
    },
    cancelEdit() {
      this.catname = '';
      this.selectcType = '1';
      this.editId = -1;
      this.quickEditId = -1;
    },
    saveEdit() {
      this.addCate();
    },
    edit(index) {
      this.catname = this.lists[index].catname;
      this.editId = index;
      this.quickEditId = index;
    },
    // async getHideCategory() {
    //   let res = await this.$http.post('/api/content/getHideCategory');
    //   this.hideCategory = res.data.data;
    // },
    async getCateList() {
      this.tableLoding = true;
      // await this.getHideCategory();
      let res = await this.$http.post('/api/content/categorylist', {
        catclass: 1,
        limit: 9999,
        type: this.type
      });
      let key = [];
      this.tableLoding = false;
      let dataList = Array.from(res.data.data);
      this.dataList = dataList;
      key = this.toTree(res.data.data);
      this.lists = this.treeKey(key);
      this.optData = this.lists;
    },
    cancelModal() {
      this.catemodal = false;
      this.catname = '';
    },
    add() {
      this.editId = -1;
      this.quickEditId = -1;
      this.catname = '';
      this.link = false;
      this.catemodal = true;
      this.intro = '';
      this.photo = '';
      this.rank = 1;
      this.level = [];
      this.template = { index: '', list: '', show: '' };
      this.templateSet = false;
      this.columnTitle = '添加栏目';
    },
    addCate() {
      if (this.catname != '') {
        let lists = this.dataList;
        // 编辑时将被编辑元素自身剔除名称重复检测
        let param = new Object();
        if (this.editId >= 0) {
          param = {
            id: this.editId,
            catname: this.catname
          };
        } else {
          param = { catname: this.catname };
        }
        if (this.link) {
          param.linkurl = this.linkurl;
        }
        if (this.intro != '') {
          param.intro = this.intro;
        }
        if (this.editId >= 0) {
          let curr = lists.findIndex(item => {
            return item.catid == this.editId;
          });
          lists.splice(curr, 1);
        }
        let exist = 0;
        // for (let i in lists) {
        //   if (lists[i].catname == this.catname) {
        //     exist++;
        //   }
        // }
        param.ctype = this.selectcType;
        param.catclass = 1;
        param.photo = this.photo;
        param.template = JSON.stringify(this.template);
        if (this.level.length > 0 && this.rank == 2) {
          param.parentid = this.level[this.level.length - 1];
          if (param.parentid == this.editId) {
            return this.$message.error('父级栏目不能选择自身');
          }
        } else if (this.rank == 1) {
          param.parentid = 0;
        }
        if (true) {
          this.$http.post('/api/content/categoryupdate', param).then(res => {
            if (res.data.state == 200) {
              if (this.editId >= 0) {
                this.$message.success('保存成功');
              } else {
                this.$message.success('添加成功');
              }

              this.lists = [];
              this.getCateList();
            } else {
              this.$message.error(
                '栏目添加失败，错误原因：' + res.data.message
              );
            }
          });
          this.editId = -1;
          this.catname = '';
          this.catemodal = false;
        }
      }
    },
    getChangeLists(vals) {
      let cataArr = [];
      for (let i in vals) {
        cataArr.push(vals[i].catid);
      }
      this.$http.post('/api/content/categorylistorder', {
        ids: cataArr.join(',')
      });
    },
    //将列表转为树形对象
    toTree(data) {
      data.forEach(item => {
        delete item.children;
      });
      let map = {};
      data.forEach(item => {
        map[item.catid] = item;
      });
      let val = [];
      data.forEach(item => {
        let parent = map[item.parentid];
        if (parent) {
          (parent.children || (parent.children = [])).push(item);
        } else {
          val.push(item);
        }
      });
      val.forEach(item => {
        item.class = 'tree-list';
        item.slots = { title: 'operation' };
      });
      return val;
    },
    treeKey(data) {
      let val = [];
      function setName(obj, ide) {
        for (let i = 0; i < obj.length; i++) {
          obj[i].title = obj[i].catname;
          obj[i].key = ide + '-' + i;
          obj[i].value = obj[i].catid;
          obj[i].label = obj[i].catname;
          if (obj[i].children) {
            setName(obj[i].children, obj[i].key);
          }
        }
        val = obj;
      }
      setName(data, '0');
      return val;
    },
    //根据id，查找整个家族
    familyTree(arr, parentid) {
      var temp = [];
      var forFn = function(arr, parentid) {
        for (var i = 0; i < arr.length; i++) {
          var item = arr[i];
          if (item.catid == parentid) {
            temp.push(item.catid);
            forFn(arr, item.parentid);
          }
        }
      };
      forFn(arr, parentid);
      return temp;
    },
    //层级选择事件
    selectHierarchy(value, selectedOptions) {
      this.level = value;
    },
    //合并层级选择
    mergeSelectHierarchy(value, selectedOptions) {
      this.mergeColData = value;
    },
    //编辑
    editColumn(data) {
      let columnCata = data;
      this.templateSet = false;
      if (columnCata.item.parentid == 0) {
        this.rank = 1;
      } else {
        this.rank = 2;
      }
      this.template = { index: '', list: '', show: '' };
      this.editId = columnCata.item.catid;
      this.catname = columnCata.item.catname;
      this.intro = columnCata.item.intro;
      this.photo = columnCata.item.photo;
      this.columnTitle = '编辑栏目';
      if (columnCata.item.parentid != 0) {
        this.level = this.familyTree(
          this.dataList,
          columnCata.item.catid
        ).reverse();
        this.level.pop(this.level);
      } else {
        this.level = [];
      }
      if (columnCata.item.linkurl != null && columnCata.item.linkurl != '') {
        this.link = true;
        this.linkurl = columnCata.item.linkurl;
      } else {
        this.link = false;
        this.linkurl = '';
      }
      if (columnCata.item.template !== null && columnCata.item.template != '') {
        this.template = JSON.parse(columnCata.item.template);
      }
      this.selectcType = data.item.ctype;
      this.catemodal = true;
    },
    //列表排序
    dataSort(key) {
      let list = [];
      let type = key.type,
        record = key.record,
        index = key.index;
      if (record.parentid != 0) {
        this.dataList.forEach(item => {
          if (item.catid == record.parentid) {
            list = item.children;
          }
        });
      } else {
        list = [...this.lists];
        if (key.pagination.current > 1) {
          //翻页时排序
          index =
            (key.pagination.current - 1) * key.pagination.pageSize + index;
        }
      }
      if (type == 'up') {
        if (index <= 0) {
          return false;
        } else {
          let after = list[index];
          let front = list[index - 1];
          list[index - 1] = after;
          list[index] = front;
        }
      } else if (type == 'down') {
        if (index >= list.length - 1) {
          return false;
        } else {
          let front = list[index];
          let after = list[index + 1];
          list[index + 1] = front;
          list[index] = after;
        }
      }
      let ids = [];
      list.forEach(item => {
        ids.push(item.catid);
      });
      this.$http
        .post('/api/content/categorylistorder', {
          ids: ids.join(',')
        })
        .then(res => {
          if (res.data.state == 200) {
            this.getCateList();
            this.$message.success('排序成功');
          }
        });
    },
    //合并
    dataMerge(data) {
      let item = data.item;
      this.mergeColData = [];
      this.mergeColVisible = true;
      this.mergePrimary = item;
    },
    categorymerge() {
      if (
        this.mergePrimary.catid ==
        this.mergeColData[this.mergeColData.length - 1]
      ) {
        this.$message.error('不能合并自身');
      } else if (this.mergeColData.length == 0) {
        this.$message.error('目标栏目不能为空');
      } else if (this.mergePrimary.children) {
        this.$message.error('该栏目有子栏目，不允许直接合并');
      } else {
        this.mergeLoading = true;
        this.$http
          .post('/api/content/categorymerge', {
            targetCatid: this.mergeColData[this.mergeColData.length - 1],
            selectedCatids: this.mergePrimary.catid
          })
          .then(res => {
            this.mergeLoading = false;
            if (res.data.state == 200) {
              this.$message.success('合并成功');
              this.mergeColVisible = false;
              this.getCateList();
            } else {
              this.$message.error('合并失败');
            }
          });
      }
    }
  }
};
</script>
<style type="text/scss" scoped>
.main {
  position: absolute;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
}
.cate-lists {
  /* width: 710px; */
  margin: 0 10px;
  padding-left: 10px;
  padding-right: 10px;
}
.catname .info {
  padding-left: 20px;
  display: none;
}

.catname:hover .info {
  color: #9ca9b3;
  display: inline-block;
}
.catname .info > i {
  margin-right: 5px;
}
.ant-btn {
  margin-right: 10px;
}
.help {
  color: #9ea1b4;
  text-align: right;
  height: 30px;
  line-height: 28px;
}
.help i {
  cursor: pointer;
}

.cate-lists .title {
  height: 55px;
  line-height: 55px;
}
.cate-lists .title .info {
  font-size: 16px;
  font-weight: bold;
}
.cate-lists .title .operator {
  cursor: pointer;
  position: absolute;
  right: 20px;
}

.lists {
  height: 50px;
  line-height: 50px;
  border-top: 2px solid #eee;
}
.lists > div {
  display: inline;
  position: absolute;
  right: 0;
}
.operator {
  position: absolute;
  right: 20px;
}
/*.listss>div>span.operator a {*/
/*margin-right: 10px;*/
/*}*/
.operator a {
  margin-right: 10px;
}
.catname {
  display: inline-block;
  width: 400px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.catname:hover {
  color: #1890ff;
}
</style>
